import qs from 'qs'

import { Metable } from '../../types/metable'
import { getCurrentLocale, getRequest } from '../../utils'
import { VatDeclarationPeriods } from './types/vatDeclarationPeriods'
import { VatDeclarationsPeriod } from './types/vatDeclarationsPeriod'

export interface VatPayment {
  accountId: string
  amount: number
  entryDate: string
  id: string
  isVoided: boolean
  returnId: string
  side: string
}

interface FetchVatPaymentResponseData extends Metable {
  salesTaxPayment: VatPayment
}

export const fetchVatPayment = (vatPaymentId: string): Promise<FetchVatPaymentResponseData> => {
  return getRequest(`/v2/salesTaxPayments/${vatPaymentId}`)
}

export interface VatDeclarationByIdResponse {
  salesTaxReturn: VatDeclarationsPeriod
}

export const fetchVatDeclarationById = (vatDeclarationId: string): Promise<VatDeclarationByIdResponse> => {
  const locale = getCurrentLocale()
  return getRequest(`/v2/salesTaxReturns/${vatDeclarationId}`, { 'accept-language': locale })
}

interface GetOrganizationVatDeclarationPeriodsResponseData extends Metable {
  periods: VatDeclarationPeriods
}

export function getOrganizationVatDeclarationPeriods(
  organizationId: string,
): Promise<GetOrganizationVatDeclarationPeriodsResponseData> {
  const locale = getCurrentLocale()
  return getRequest(`/v2/vat/periods/${organizationId}`, { 'accept-language': locale })
}

interface SkatConnectionResponseData {
  /* eslint-disable @typescript-eslint/naming-convention */
  connected: boolean
  code?: string
  deep_link?: string
  is_approved?: boolean
  /* eslint-enable @typescript-eslint/naming-convention */
}

export const fetchSkatConnection = async (
  organizationId: string,
  registrationNo?: string,
  skatTransactionId?: string,
): Promise<SkatConnectionResponseData> => {
  const queryParams = qs.stringify({
    ...(registrationNo ? { registrationNumber: registrationNo } : {}),
    ...(skatTransactionId ? { transactionId: skatTransactionId } : {}),
  })

  return getRequest(`/integrations/skat/organizations/${organizationId}/status?${queryParams}`)
}
